/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectItemSubmittalCommand } from '../../models/delete-project-item-submittal-command';
import { DeleteProjectItemSubmittalCommandResult } from '../../models/delete-project-item-submittal-command-result';

export interface ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Params {
  
    /**
     * The command to delete a project item submittal.
     */
    body?: DeleteProjectItemSubmittalCommand
}

export function apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectItemSubmittalCommandResult>;
    })
  );
}

apiProjectItemSubmittalsDeleteProjectItemSubmittalDelete$Plain.PATH = '/api/ProjectItemSubmittals/DeleteProjectItemSubmittal';
